import { Component } from "react";
import { extract, EventAggregator, GhostButton } from "@parksandresorts/core";
import styles from "./expand-content.module.less";

import EventAttributeStore from "components/stores/event-attribute-store.js";
import SiteConfigurationStore from "components/stores/site-configuration-store";

export default class ExpandContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      beforeExpandYPosition: null,
    };

    this.iconClassExpanded = extract(props, "iconClassExpanded");
    this.iconClassContracted = extract(props, "iconClassContracted");
    this.expandLabel = extract(props, "expandLabel", SiteConfigurationStore.getLabel("READ_MORE"));
    this.shrinkLabel = extract(props, "shrinkLabel", SiteConfigurationStore.getLabel("READ_LESS"));
    this.labelStyle = extract(props, "labelStyle");
    this.buttonStyle = extract(props, "buttonStyle");

    this.iconStyles = {
      icon: this.iconClassContracted ? this.iconClassContracted : "add",
      iconToggle: this.iconClassExpanded ? this.iconClassExpanded : "remove",
    };
  }

  toggleContentState() {
    let scrollPosY = null;
    if (!this.state.expanded) {
      scrollPosY = EventAttributeStore.getCurrentScrollY();
    } else {
      if (window !== "undefined" && this.scrolledPastHalfViewPort()) {
        window.scroll({
          top: this.state.beforeExpandYPosition,
          behavior: "smooth",
        });
      }
    }

    this.setState({ expanded: !this.state.expanded, beforeExpandYPosition: scrollPosY });

    EventAggregator.publish("trackEvent", {
      category: "Read More",
      action: this.state.expanded ? "Collapsed" : "Expanded",
      label: this.blockTitle ? this.blockTitle : document.title,
    });
  }

  scrolledPastHalfViewPort() {
    const scrolledPastLimit = this.state.beforeExpandYPosition + EventAttributeStore.getCurrentWindowHeight() / 2;
    return EventAttributeStore.getCurrentScrollY() > scrolledPastLimit;
  }

  render() {
    return (
      <div className={styles.expandWrapper}>
        <div
          className={[
            styles.contentWrapper,
            this.state.expanded ? styles.contentWrapperExpanded : styles.contentWrapperContracted,
          ].join(" ")}
        >
          {this.props.children}
        </div>
        <div
          className={[
            styles.label,
            this.labelStyle ? this.labelStyle : "",
            this.state.expanded ? styles.expandedLabel : styles.contractedLabel,
          ].join(" ")}
        >
          {this.expandLabel && this.shrinkLabel && (
            <GhostButton
              onClick={() => this.toggleContentState()}
              iconLeftNew={this.state.expanded ? "remove" : "add"}
              className={[styles.labelButton, this.buttonStyle ? this.buttonStyle : ""].join(" ")}
              label={this.state.expanded ? this.shrinkLabel : this.expandLabel}
            />
          )}
        </div>
      </div>
    );
  }
}
